export default __webpack_public_path__ + "static/media/0138.7a3e17a6.png";